module.exports = __webpack_public_path__ + "static/media/25th Avenue, San Francisco, CA2.d4ab4e73.jpg";